import { ClientType } from "types/ClientType";
import { downloadFile, getCurrencyFromUuid } from "utils";
import { SharesByCompanyType } from "types/SharesTypes";
import { CompanyMyType, CompanyType } from "types/CompanyTypes";
import { TransactionType } from "types/TransactionsTypes";
import moment from "moment";
import { SVG_ENUM } from "enums";
import { SVG, ContextMenu } from "shared";

const items = ({
  item,
  setEditTransaction,
  company,
}: {
  item: SharesByCompanyType;
  setEditTransaction: (company: SharesByCompanyType) => void;
  company: CompanyType | null;
}) => {
  return (item: any) => {
    const actions = [];
    actions.push({
      name: "Edytuj",
      action: () =>
        setEditTransaction({
          ...item,
          name: company?.name || "",
          availableShares: company?.availableShares,
          isStock: company?.type === "stock",
        }),
      svg: SVG_ENUM.EDIT,
    });
    if (item.file) {
      actions.push({
        name: "Pobierz",
        action: () =>
          downloadFile({ name: item.file.name, url: item.file.url }),
        svg: SVG_ENUM.FILE,
      });
    }
    return actions;
  };
};

export const mobileColumns = ({ company }: { company: CompanyType | null }) => [
  {
    width: "calc(100% - 20px)",
    render: (data: ClientType | any) => {
      if (data?.type === "transformation") {
        return (
          <div className="company-details-transformation company-details-transformation--mobile">
            <div className="company-details-transformation__title">
              <span className="company-details-transformation__icon">
                <SVG type={SVG_ENUM.WARNING_CLOUD} />
              </span>
              <div className="company-details-transformation__title-wrap">
                <div className="company-details-transformation__date">
                  {data?.transformedAt
                    ? moment(data.transformedAt).format("DD/MM/YYYY")
                    : data?.completedAt
                    ? moment(data.completedAt).format("DD/MM/YYYY")
                    : ""}
                </div>
                Zmiana rodzaju spółki na spółkę akcyjną
              </div>
            </div>
            <div className="company-details-transformation__row">
              <span className="company-details-transformation__label">
                Parytet wymiany
              </span>
              <span className="company-details-transformation__value">
                {data?.exchangeRatio || "-"}
              </span>
            </div>
            <div className="company-details-transformation__row">
              <span className="company-details-transformation__label">
                Ilość udziałów
              </span>
              <span className="company-details-transformation__value">
                {data?.sharesBeforeTransformation ?? "-"}
              </span>
              <span className="company-details-transformation__arrow">
                <SVG type={SVG_ENUM.CHEVRON} />
              </span>
              <span className="company-details-transformation__label company-details-transformation__label--count">
                Ilość akcji
              </span>
              <span className="company-details-transformation__value">
                {data?.sharesAfterTransformation ?? "-"}
              </span>
            </div>
          </div>
        );
      }

      return (
        <table className="side-modal__table">
          <tr>
            <td className="side-modal__table-label">Klient:</td>
            <td className="side-modal__table-cell">{data?.name || "-"}</td>
          </tr>
          <tr>
            <td className="side-modal__table-label">Data:</td>
            <td className="side-modal__table-cell">
              {moment(data.createdAt).format("DD/MM/YYYY")}
            </td>
          </tr>
          <tr>
            <td className="side-modal__table-label">Zakupione udziały:</td>
            <td className="side-modal__table-cell">
              {data.sharesCount || "-"}
            </td>
          </tr>
          <tr>
            <td className="side-modal__table-label">Wartość udziałów:</td>
            <td className="side-modal__table-cell">
              {data?.sharesValue || "-"}{" "}
              {data?.pricePerShare && company
                ? getCurrencyFromUuid(company?.currencyUuid)
                : null}
            </td>
          </tr>

          <tr>
            <td className="side-modal__table-label">
              Wartość jednego udziału:
            </td>
            <td className="side-modal__table-cell">
              {data?.pricePerShare || "-"}{" "}
              {data?.pricePerShare && company
                ? getCurrencyFromUuid(company?.currencyUuid)
                : null}
            </td>
          </tr>
        </table>
      );
    },
  },
];

export const desktopColumns = ({
  company,
  setEditTransaction,
}: {
  company: CompanyType | null;
  setEditTransaction: (company: SharesByCompanyType) => void;
}) => {
  return [
    {
      title: "Klient",
      width: 150,
      render: (item: any) => {
        if (item?.type === "transformation") {
          return {
            children: (
              <div className="company-details-transformation">
                <div className="company-details-transformation__title">
                  <span className="company-details-transformation__icon">
                    <SVG type={SVG_ENUM.WARNING_CLOUD} />
                  </span>
                  <div className="company-details-transformation__title-wrap">
                    <div className="company-details-transformation__date">
                      {item?.transformedAt
                        ? moment(item.transformedAt).format("DD/MM/YYYY")
                        : item?.completedAt
                        ? moment(item.completedAt).format("DD/MM/YYYY")
                        : ""}
                    </div>
                    Zmiana rodzaju spółki na spółkę akcyjną
                  </div>
                </div>
                <div className="company-details-transformation__row">
                  <span className="company-details-transformation__label">
                    Parytet wymiany
                  </span>
                  <span className="company-details-transformation__value">
                    {item?.exchangeRatio || "-"}
                  </span>
                </div>
                <div className="company-details-transformation__row">
                  <span className="company-details-transformation__label">
                    Ilość udziałów
                  </span>
                  <span className="company-details-transformation__value">
                    {item?.sharesBeforeTransformation ?? "-"}
                  </span>
                  <span className="company-details-transformation__arrow">
                    <SVG type={SVG_ENUM.CHEVRON} />
                  </span>
                  <span className="company-details-transformation__label company-details-transformation__label--count">
                    Ilość akcji
                  </span>
                  <span className="company-details-transformation__value">
                    {item?.sharesAfterTransformation ?? "-"}
                  </span>
                </div>
              </div>
            ),
            props: { colSpan: 7 },
          } as any;
        }

        return <span className="clients-table__name">{item?.name || "-"}</span>;
      },
    },
    {
      title: "Data",
      width: 150,
      dataIndex: "completedAt",
      key: "completedAt",
      render: (item: string, row: any) => {
        if (row?.type === "transformation") {
          return { children: null, props: { colSpan: 0 } } as any;
        }
        return item ? moment(item).format("DD/MM/YYYY") : "-";
      },
    },
    {
      title: "Ilość sztuk",
      width: 100,
      render: (item: SharesByCompanyType, row: any) => {
        if (row?.type === "transformation") {
          return { children: null, props: { colSpan: 0 } } as any;
        }
        return (
          <span className={`transactions-table__number`}>
            {item.name === "Reliance"
              ? item.sharesCount
              : `-${item.sharesCount}`}
          </span>
        );
      },
    },
    {
      title: "Umowa",
      width: 100,
      render: (item: TransactionType, row: any) => {
        if (row?.type === "transformation") {
          return { children: null, props: { colSpan: 0 } } as any;
        }
        return (
          <>
            {item.fileId ? (
              <SVG
                className="transactions-table__files-check"
                type={SVG_ENUM.FILES_CHECK}
              />
            ) : (
              "Brak"
            )}
          </>
        );
      },
    },
    {
      title: "Koszt nabycia",
      width: 120,
      render: (item: SharesByCompanyType, row: any) => {
        if (row?.type === "transformation") {
          return { children: null, props: { colSpan: 0 } } as any;
        }
        return item?.sharesValue ? (
          <span className={`transactions-table__number `}>
            {item?.sharesValue}{" "}
            {company?.currencyUuid &&
              getCurrencyFromUuid(company?.currencyUuid)}
          </span>
        ) : (
          "-"
        );
      },
    },
    {
      title: "Cena nabycia",
      width: 120,
      render: (item: SharesByCompanyType, row: any) => {
        if (row?.type === "transformation") {
          return { children: null, props: { colSpan: 0 } } as any;
        }
        return item?.sharesValue ? (
          <span className={`transactions-table__number `}>
            {item?.pricePerShare}{" "}
            {company?.currencyUuid &&
              getCurrencyFromUuid(company?.currencyUuid)}
          </span>
        ) : (
          "-"
        );
      },
    },
    {
      width: 60,
      render: (item: SharesByCompanyType | any) => {
        if (item?.type === "transformation") {
          return { children: null, props: { colSpan: 0 } } as any;
        }
        return (
          <ContextMenu
            data={item}
            items={items({
              item,
              setEditTransaction,
              company,
            })(item)}
          >
            <SVG type={SVG_ENUM.DOTS} />
          </ContextMenu>
        );
      },
    },
  ];
};
export const summaryColumns = (item: any) => [
  {
    key: "type",
    width: 300,
    render: () => {
      return "Razem";
    },
  },
  {
    width: 150,
    render: (item: CompanyMyType) => {
      return item?.totalShareCount || 0;
    },
  },
  {
    width: 300,
  },

  {
    width: 30,
  },
  {
    width: 40,
  },
];
